module.exports = [
    { name: 'info', url: '/info' },
    { name: 'join', url: '/apply' },
    { name: 'product', url: '/product' },
    { name: 'official', url: '/official' },
];
